import React, { useState } from 'react';
import Language from '@Components/Language';
import { Control } from 'react-hook-form';
import { InputLabel, InputTextField } from '@App/Components';
import { Button } from 'primereact/button';

interface ButtonPasswordProps {
  control: Control | any;
}

export default function ButtonPassword(props: ButtonPasswordProps) {
  const { control } = props;

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  return (
    <>
      <InputTextField
        control={control}
        dusk="password"
        placeholder={Language.get('Password')}
        name="password"
        type={isPasswordVisible ? 'text' : 'password'}
        className="border-1 border-800 px-2 py-0 login-input border-round-right h-3rem"
        pt={{ root: { className: 'm-0 border-1 border-bluegray-200' } }}
        validate={(value: string) => value?.length >= 3 || Language.get('Password must be at least 3 letters')}
        errorTextClassName="errorTextError"
      />
      <InputLabel htmlFor="password" className="pl-2" style={{ top: '1.5rem' }}>
        {Language.get('Password')}
      </InputLabel>

      <Button
        type="button"
        icon={`pi pi-eye${isPasswordVisible ? '-slash' : ''}`}
        onClick={togglePasswordVisibility}
        className="p-button-text absolute p-0 m-0"
        style={{
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--teal-700)',
        }}
        aria-label="Toggle password visibility"
      />
    </>
  );
}
